// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'

import {fetchBigButtonsStatus} from '../../../../actions/bigButtons'

import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import ContactSupportIcon from '@material-ui/icons/ContactSupportOutlined'

import {iptvImg, ottImg, multiDrmImg, omiImg} from '../../../../media/AnalyticsLanding/exports'

import {
  ANALYTICS_PATH,
  SERVICES_PATH,
  MULTIDRM_ACTIVITY_PATH,
  IPTV_ACTIVITY_PATH,
  OTT_ACTIVITY_PATH,
  API_ACTIVITY_PATH
} from '../navigation'
import './index.css'

class AnalyticsLanding extends Component {
  componentDidMount () {
    this.props.fetchBigButtonsStatus()
  }

  isEmpty (obj) {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key))
        return false
    }
    return true
  }

  renderButton (link, enabled) {
    if (enabled) {
      return (
        <Link to={link}>
          <button className='btn-with-icon btn-open'>
            <span>Open</span>
            <div className='icon'>
              <MenuOpenIcon />
            </div>
          </button>
        </Link>
      )
    } else {
      return (
        <a href={'https://www.verimatrix.com/online-contact-form'} rel='noopener noreferrer' target='_blank'>
          <button className='btn-with-icon btn-contact-sales'>
            <span>Contact our sales team</span>
            <div className='icon'>
              <ContactSupportIcon />
            </div>
          </button>
        </a>
      )
    }
  }


  render () {
    let {bigButtonsStatus} = this.props

    if (bigButtonsStatus && !this.isEmpty(bigButtonsStatus)) {
      return (
        <div className='analytics-landing'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='div-dashboard'>
                <div className='title'>VCAS Multi DRM Activity</div>
                <img src={multiDrmImg} alt='VCAS Multi DRM Activity'/>
                {this.renderButton(`/${ANALYTICS_PATH}/${SERVICES_PATH}/${MULTIDRM_ACTIVITY_PATH}/`, bigButtonsStatus['MULTIRIGHTSDashboard'])}
              </div>
            </div>
            <div className='col-md-4'>
              <div className='div-dashboard'>
                <div className='title'>VCAS IPTV Activity</div>
                <img src={iptvImg} alt='VCAS IPTV Activity'/>
                { this.renderButton(`/${ANALYTICS_PATH}/${SERVICES_PATH}/${IPTV_ACTIVITY_PATH}/`, bigButtonsStatus['IPTVDashboard']) }
              </div>
            </div>
            <div className='col-md-4'>
              <div className='div-dashboard'>
                <div className='title'>VCAS OTT Activity</div>
                <img src={ottImg} alt='VCAS OTT Activity'/>
                { this.renderButton(`/${ANALYTICS_PATH}/${SERVICES_PATH}/${OTT_ACTIVITY_PATH}/`, bigButtonsStatus['OTTDashboard']) }
              </div>
            </div>
            <div className='col-md-4'>
              <div className='div-dashboard'>
                <div className='title'>VCAS API Activity</div>
                <img src={omiImg} alt='VCAS OMI Activity'/>
                { this.renderButton(`/${ANALYTICS_PATH}/${SERVICES_PATH}/${API_ACTIVITY_PATH}/`, bigButtonsStatus['APIDashboard']) }
              </div>
            </div>
          </div>
        </div>
      )
    }

    return null
  }
}

function mapStateToProps ({session, bigButtons}) {
  return {
    session: session,
    bigButtonsStatus: bigButtons.bigButtonsStatus
  }
}

export default connect(mapStateToProps, {fetchBigButtonsStatus})(AnalyticsLanding)
